import { Injectable } from '@angular/core';
import { Subject } from 'rxjs'
@Injectable({
  providedIn: 'root'
})
export class ObservablesService {
  toastMessageStatus:any = new Subject<any>();
  menuStatus:any = new Subject<any>();
  setPartyStatus:any = new Subject<any>();
  setRangeDateStatus:any = new Subject<any>();
  setClientStatus:any = new Subject<any>();
  getHeaderStatus:any = new Subject<any>();
  setHeaderData:any = new Subject<any>();
  setTagData:any = new Subject<any>();
  refreshSlipListStatus:any = new Subject<any>();
  refreshSelectStatus:any = new Subject<any>();
  refreshHeaderPartyStatus:any = new Subject<any>();
  changePasswordStatus:any = new Subject<any>();
  resetPartySearchStatus:any = new Subject<any>();
  showMobileDashboardStatus:any = new Subject<any>();
  tagPopupStatus:any = new Subject<any>();
  setInvoicedSlips:any = new Subject<any>();
  setSlipNumberStatus:any = new Subject<any>();
  setInvoiceNumberStatus:any = new Subject<any>();
  showSlipViewStatus:any = new Subject<any>();
  invoiceViewStatus:any = new Subject<any>();
  profileUpdateStatus:any = new Subject<any>();
  refreshTagsStatus:any = new Subject<any>();
  updateProductsArrStatus:any = new Subject<any>();

  constructor() { }

  showToastMessage(data){
    this.toastMessageStatus.next(data);
  }

  setMenuStatus(data){
    this.menuStatus.next(data);
  }

  getSelectedPartyData(data){
    this.setPartyStatus.next(data);
  }
  getSelectedDateRangeData(data){
    this.setRangeDateStatus.next(data);
  }
}
